<template>
  <div>
    <span v-if="project && canReadProjects">
      <router-link :to="`/projects/${project.id}`">{{ project.name }}</router-link>
    </span>
    <span v-else>
      {{ lodash.get(project, 'name') || 'Orphaned' }}
    </span>
    <el-tooltip v-if="project.description" class="item" effect="dark" :content="viewDescriptionNoHtml()" placement="right-end">
      <img class="icon-help m-left-4" src="static/img/icon-info.png" />
    </el-tooltip>
  </div>
</template>

<script>
import Permissions from '@/utilities/permissions'
import {stripHTML} from '@/utilities/utils'
import lodash from 'lodash'

export default {
  props: ['data'],
  computed: {
    canReadProjects() {
      return this.$can('read', Permissions.PROJECTS)
    },
    project() {
      if (!this.data) {
        console.error("'data' prop must contain a project object. It is missing and is required")
        return {}
      }
      return this.data
    }
  },
  data() {
    return {
      lodash
    }
  },
  methods: {
    viewDescriptionNoHtml() {
      return stripHTML(this.project.description)
    }
  }
}
</script>
